import { render, staticRenderFns } from "./ResidualValuesEditor.vue?vue&type=template&id=c112ba4c&scoped=true"
import script from "./ResidualValuesEditor.vue?vue&type=script&lang=js"
export * from "./ResidualValuesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c112ba4c",
  null
  
)

export default component.exports